import { render, staticRenderFns } from "./vsTable.vue?vue&type=template&id=3988565d"
import script from "./vsTable.vue?vue&type=script&lang=js"
export * from "./vsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports